<template>
  <v-form
    ref="createUserForm"
    v-model="isFormValid"
    class="create-user"
    @submit.prevent="submitForm"
  >
    <label class="input-label">Adres e-mail konta:</label>
    <v-text-field
      v-model="email"
      v-bind="props.validatedField"
      placeholder="Wprowadź adres e-mail"
      :rules="[rules.required, rules.email]"
    />

    <label class="input-label">Uprawnienia</label>
    <v-autocomplete
      v-model="roles"
      placeholder="Wybierz role użytkownika"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      :items="filtersOptions.roles"
      item-text="label"
      item-value="name"
      :menu-props="{ 'offset-y': true }"
      multiple
    >
      <template #selection="{ item, index }">
        <template v-if="index < 2">
          <span
            v-if="index > 0"
            class="mr-1"
          >,</span>

          <span class="max-width-160 overflow-ellipsis">
            {{ item.label }}
          </span>
        </template>

        <span
          v-if="index === 2"
          class="ml-1"
        >(+{{ roles.length - 2 }})</span>
      </template>
    </v-autocomplete>

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      type="submit"
    >
      Stwórz konto
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';

export default {
  data() {
    return {
      props,
      rules,
      name: '',
      email: '',
      roles: [],
      isFormValid: null,
    };
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },

  methods: {
    ...mapActions('users', [
      'createUser',
    ]),

    submitForm() {
      this.$refs.createUserForm.validate();
      const { email, roles } = this;
      if (this.isFormValid) {
        this.createUser({ email, roles });
      }
    },
  },

};
</script>
